<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <!-- <bc-btn-add
                                v-if="hasPerm('nonconformance_hold_tags.create')"
                                @invoke-method="invokeMethod($event)"
                                action="openNonconformanceHoldTagForm"
                            ></bc-btn-add> -->
                            <bc-btn-refresh @invoke-method="dbGetNonconformanceHoldTags(true)"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile>
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>
                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-switch
                                                v-model="filter.status"
                                                color="success"
                                                :label="filter.status == '1' ? $t('lang.active') : $t('lang.inactive')"
                                                true-value="1"
                                                false-value="0"
                                            ></v-switch>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="nonconformance_hold_tags" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="openNonconformanceHoldTagForm(props.item)">
                                <td>{{ props.item.hold_tag_id }}</td>
                                <td>{{ props.item.nonconformance_id }}</td>
                                <td>{{ props.item.reason }}</td>
                                <td>{{ props.item.verified_by }}</td>
                                <td>{{ props.item.verified_date }}</td>
                                <td>{{ props.item.nine_point_submission }}</td>
                                <td>{{ props.item.nine_point_submission_by }}</td>
                                <td>{{ props.item.nine_point_submission_date }}</td>
                                <td>{{ props.item.strip_chart }}</td>
                                <td>{{ props.item.strip_chart_by }}</td>
                                <td>{{ props.item.strip_chart_date }}</td>
                                <td>{{ props.item.recipe_sheet }}</td>
                                <td>{{ props.item.recipe_sheet_by }}</td>
                                <td>{{ props.item.recipe_sheet_date }}</td>
                                <td>{{ props.item.process_sheet }}</td>
                                <td>{{ props.item.process_sheet_by }}</td>
                                <td>{{ props.item.process_sheet_date }}</td>
                                <td>{{ props.item.customer_contacted_by }}</td>
                                <td>{{ props.item.customer_contacted_date }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="nonconformance_hold_tags"></bc-pagination>
                </v-card-text>
            </v-card>

            <!-- <bc-dialog :value="nonconformance_hold_tag_dialog">
                <v-card>
                    <v-form ref="form_nonconformance_hold_tag">
                        <v-card-title>
                            <span class="headline">{{
                                nonconformance_hold_tag.hold_tag_id ? $t("lang.edit_nonconformance_hold_tag") : $t("lang.add_nonconformance_hold_tag")
                            }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeNonconformanceHoldTagDialog"
                                :dialog-status="nonconformance_hold_tag_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-focus="nonconformance_hold_tag_dialog"
                                            v-model="nonconformance_hold_tag.hold_tag_id"
                                            :label="`${$t('lang.hold_tag_id')} *`"
                                            :counter="showCounter(nonconformance_hold_tag.hold_tag_id, 'nonconformance_hold_tags.hold_tag_id')"
                                            :rules="ifValid('nonconformance_hold_tags.hold_tag_id')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="nonconformance_hold_tag.nonconformance_id"
                                            :label="$t('lang.nonconformance_id')"
                                            :counter="showCounter(nonconformance_hold_tag.nonconformance_id, 'nonconformance_hold_tags.nonconformance_id')"
                                            :rules="ifValid('nonconformance_hold_tags.nonconformance_id')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-textarea
                                            v-model="nonconformance_hold_tag.reason"
                                            :label="`${$t('lang.reason')} *`"
                                            auto-grow
                                            rows="1"
                                            :rules="ifValid('nonconformance_hold_tags.reason')"
                                        ></v-textarea>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="nonconformance_hold_tag.verified_by"
                                            :label="$t('lang.verified_by')"
                                            :items="verified_by"
                                            item-value="value"
                                            item-text="text"
                                            :rules="ifValid('nonconformance_hold_tags.verified_by')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-date-picker
                                            v-model="nonconformance_hold_tag.verified_date"
                                            :label="$t('lang.verified_date')"
                                            :rules="ifValid('nonconformance_hold_tags.verified_date')"
                                        ></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-select
                                            v-model="nonconformance_hold_tag.nine_point_submission"
                                            :label="`${$t('lang.nine_point_submission')} *`"
                                            :items="[]"
                                            item-value="value"
                                            item-text="text"
                                            :rules="ifValid('nonconformance_hold_tags.nine_point_submission')"
                                        ></bc-select>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="nonconformance_hold_tag.nine_point_submission_by"
                                            :label="$t('lang.nine_point_submission_by')"
                                            :items="nine_point_submission_by"
                                            item-value="value"
                                            item-text="text"
                                            :rules="ifValid('nonconformance_hold_tags.nine_point_submission_by')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-date-picker
                                            v-model="nonconformance_hold_tag.nine_point_submission_date"
                                            :label="$t('lang.nine_point_submission_date')"
                                            :rules="ifValid('nonconformance_hold_tags.nine_point_submission_date')"
                                        ></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-select
                                            v-model="nonconformance_hold_tag.strip_chart"
                                            :label="`${$t('lang.strip_chart')} *`"
                                            :items="[]"
                                            item-value="value"
                                            item-text="text"
                                            :rules="ifValid('nonconformance_hold_tags.strip_chart')"
                                        ></bc-select>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="nonconformance_hold_tag.strip_chart_by"
                                            :label="$t('lang.strip_chart_by')"
                                            :items="strip_chart_by"
                                            item-value="value"
                                            item-text="text"
                                            :rules="ifValid('nonconformance_hold_tags.strip_chart_by')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-date-picker
                                            v-model="nonconformance_hold_tag.strip_chart_date"
                                            :label="$t('lang.strip_chart_date')"
                                            :rules="ifValid('nonconformance_hold_tags.strip_chart_date')"
                                        ></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-select
                                            v-model="nonconformance_hold_tag.recipe_sheet"
                                            :label="`${$t('lang.recipe_sheet')} *`"
                                            :items="[]"
                                            item-value="value"
                                            item-text="text"
                                            :rules="ifValid('nonconformance_hold_tags.recipe_sheet')"
                                        ></bc-select>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="nonconformance_hold_tag.recipe_sheet_by"
                                            :label="$t('lang.recipe_sheet_by')"
                                            :items="recipe_sheet_by"
                                            item-value="value"
                                            item-text="text"
                                            :rules="ifValid('nonconformance_hold_tags.recipe_sheet_by')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-date-picker
                                            v-model="nonconformance_hold_tag.recipe_sheet_date"
                                            :label="$t('lang.recipe_sheet_date')"
                                            :rules="ifValid('nonconformance_hold_tags.recipe_sheet_date')"
                                        ></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-select
                                            v-model="nonconformance_hold_tag.process_sheet"
                                            :label="$t('lang.process_sheet')"
                                            :items="[]"
                                            item-value="value"
                                            item-text="text"
                                            :rules="ifValid('nonconformance_hold_tags.process_sheet')"
                                        ></bc-select>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="nonconformance_hold_tag.process_sheet_by"
                                            :label="$t('lang.process_sheet_by')"
                                            :items="process_sheet_by"
                                            item-value="value"
                                            item-text="text"
                                            :rules="ifValid('nonconformance_hold_tags.process_sheet_by')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-date-picker
                                            v-model="nonconformance_hold_tag.process_sheet_date"
                                            :label="$t('lang.process_sheet_date')"
                                            :rules="ifValid('nonconformance_hold_tags.process_sheet_date')"
                                        ></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="nonconformance_hold_tag.customer_contacted_by"
                                            :label="$t('lang.customer_contacted_by')"
                                            :items="customer_contacted_by"
                                            item-value="value"
                                            item-text="text"
                                            :rules="ifValid('nonconformance_hold_tags.customer_contacted_by')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-date-picker
                                            v-model="nonconformance_hold_tag.customer_contacted_date"
                                            :label="$t('lang.customer_contacted_date')"
                                            :rules="ifValid('nonconformance_hold_tags.customer_contacted_date')"
                                        ></bc-date-picker>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn
                                v-if="nonconformance_hold_tag.hold_tag_id"
                                color="error"
                                @mouseup.left="$refs.delete_nonconformance_hold_tags.openDialog()"
                                >{{ $t("lang.delete") }}</v-btn
                            >
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeNonconformanceHoldTagDialog()">{{ $t("lang.cancel") }}</v-btn>
                            <v-btn color="success" @click="saveNonconformanceHoldTags">{{ $t("lang.save") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog> -->
            <delete-confirmation-dialog
                ref="delete_nonconformance_hold_tags"
                :heading="$t('lang.delete_nonconformance_hold_tag')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteNonconformanceHoldTags(nonconformance_hold_tag.hold_tag_id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openNonconformanceHoldTagForm" },
                { title: this.$t("lang.refresh"), action: "dbGetNonconformanceHoldTags", params: [true] },
            ],
            headers: [
                { text: this.$t("lang.hold_tag_id"), sortable: false, width: "5%" },
                { text: this.$t("lang.nonconformance_id"), sortable: false, width: "5%" },
                { text: this.$t("lang.reason"), sortable: false, width: "5%" },
                { text: this.$t("lang.verified_by"), sortable: false, width: "5%" },
                { text: this.$t("lang.verified_date"), sortable: false, width: "5%" },
                { text: this.$t("lang.nine_point_submission"), sortable: false, width: "5%" },
                { text: this.$t("lang.nine_point_submission_by"), sortable: false, width: "5%" },
                { text: this.$t("lang.nine_point_submission_date"), sortable: false, width: "5%" },
                { text: this.$t("lang.strip_chart"), sortable: false, width: "5%" },
                { text: this.$t("lang.strip_chart_by"), sortable: false, width: "5%" },
                { text: this.$t("lang.strip_chart_date"), sortable: false, width: "5%" },
                { text: this.$t("lang.recipe_sheet"), sortable: false, width: "5%" },
                { text: this.$t("lang.recipe_sheet_by"), sortable: false, width: "5%" },
                { text: this.$t("lang.recipe_sheet_date"), sortable: false, width: "5%" },
                { text: this.$t("lang.process_sheet"), sortable: false, width: "5%" },
                { text: this.$t("lang.process_sheet_by"), sortable: false, width: "5%" },
                { text: this.$t("lang.process_sheet_date"), sortable: false, width: "5%" },
                { text: this.$t("lang.customer_contacted_by"), sortable: false, width: "5%" },
                { text: this.$t("lang.customer_contacted_date"), sortable: false, width: "5%" },
            ],
            enableAddModal: true,
            enableEditModal: true,

            nonconformance_hold_tag: {},
            filter: {
                search: "",
                status: "1",
            },
            nonconformance_hold_tag_dialog: false,
            dbGetNonconformanceHoldTags: _.debounce(this.getNonconformanceHoldTags, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchNonconformanceHoldTags", {
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.nonconformance_hold_tags) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.fetchNonconformanceHoldTags({
            body: parsedQuery,
        }).then((data) => {
            if (typeof data !== "undefined" && data.nonconformance_hold_tags) {
                this.setQuery(parsedQuery, this.filter, this.default_filter);
                this.finishLoader();
                next();
            } else {
                next({ name: "dashboard", replace: true });
            }
        });
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.nonconformance_hold_tags.nonconformance_hold_tags_filter,
            page: (state) => state.nonconformance_hold_tags.page,
            rules_nonconformance_hold_tags: (state) => state.nonconformance_hold_tags.rules_nonconformance_hold_tags,
            nonconformance_hold_tag_status_options: (state) => state.settings.nonconformance_hold_tag_status_options,
            nonconformance_hold_tags: (state) => state.nonconformance_hold_tags.nonconformance_hold_tags,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchNonconformanceHoldTags", "saveNonconformanceHoldTag", "deleteNonconformanceHoldTag"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openNonconformanceHoldTagForm(item = null) {
            if (item != null) {
                if (this.enableEditModal) {
                    if (this.$refs.form_nonconformance_hold_tag)
                        item ? this.$refs.form_nonconformance_hold_tag.resetValidation() : this.$refs.form_nonconformance_hold_tag.reset();

                    this.$nextTick(() => {
                        this.nonconformance_hold_tag = item != null ? this.assignObj2(item, this.rules_nonconformance_hold_tags) : {};
                        this.nonconformance_hold_tag_dialog = true;
                    });
                } else {
                    this.$router.push({ name: "nonconformance_hold_tag", params: { id: item.hold_tag_id } });
                }
            } else {
                if (this.enableAddModal) {
                    if (this.$refs.form_nonconformance_hold_tag)
                        item ? this.$refs.form_nonconformance_hold_tag.resetValidation() : this.$refs.form_nonconformance_hold_tag.reset();
                    this.nonconformance_hold_tag_dialog = true;
                } else {
                    this.$router.push({ name: "nonconformance_hold_tag" });
                }
            }
        },
        saveNonconformanceHoldTags() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_nonconformance_hold_tag")) {
                    let body = this.prepForm(this.nonconformance_hold_tag, this.rules_nonconformance_hold_tags);

                    this.saveNonconformanceHoldTag({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            if (this.enableEditModal) {
                                this.getNonconformanceHoldTags();
                                this.closeNonconformanceHoldTagDialog();
                            } else {
                                this.$router.push({ name: "nonconformance_hold_tag", params: { id: data.hold_tag_id } });
                            }
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deleteNonconformanceHoldTags(id = null) {
            this.deleteNonconformanceHoldTag({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getNonconformanceHoldTags();
                    this.closeNonconformanceHoldTagDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },

        closeNonconformanceHoldTagDialog() {
            this.nonconformance_hold_tag_dialog = false;
            this.$refs.delete_nonconformance_hold_tags.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        getNonconformanceHoldTags(pg_refresh = false) {
            this.startLoader();

            this.fetchNonconformanceHoldTags({
                body: JSON.parse(JSON.stringify(this.$route.query)),
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.nonconformance_hold_tag_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                });
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "me/companies?module=people",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.companies;
                    }
                });
        },
    },
};
</script>
